import { useState, useRef, useEffect } from 'react';
import { Keyboard } from '../constants/globalConstants';

export const useDropdown = () => {
  const [dropdownHidden, setDropdownHidden] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const hideDropdown = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownHidden(false);
      }
    };
    window.addEventListener('click', hideDropdown);
    return () => {
      window.removeEventListener('click', hideDropdown);
    };
  }, []);
  // Toggle dropdown on click
  const toggleDropdown = () => {
    setDropdownHidden((prev) => !prev);
  };

  const openDropDown = (e) => {
    e.stopPropagation();
    const code = e && (e.keyCode || e.which);
    const listItems = e.target && e.target.querySelectorAll('#exp_elem_list li');
    if (code === Keyboard.ENTER || e.type === 'click') {
      setDropdownHidden(!dropdownHidden);
    } else if (code === Keyboard.ESCAPE || code === Keyboard.TAB) {
      setDropdownHidden(false);
    } else if (code === Keyboard.DOWN) {
      listItems && listItems[0] && listItems[0].focus();
      e.preventDefault();
    }
  };

  const focusActiveEelement = (e) => {
    const filterDropdwonBar = e.target.parentElement.parentElement.parentElement;
    const options = filterDropdwonBar && filterDropdwonBar.querySelector('non-keyboard-outline');
    options &&
      options.classList &&
      options.classList.contains('non-keyboard-outline') &&
      options.classList.remove('non-keyboard-outline');
    setTimeout(() => {
      filterDropdwonBar && filterDropdwonBar.classList.add('non-keyboard-outline');
      filterDropdwonBar.focus();
    }, 100);
  };

  const focusListItem = (e, index, callback, data) => {
    e.stopPropagation();
    const code = e && (e.keyCode || e.which);
    const listItems = document.querySelectorAll('#exp_elem_list li');
    if (code === Keyboard.DOWN) {
      e.preventDefault();
      listItems && listItems[index + 1] && listItems[index + 1].focus();
    } else if (code === Keyboard.UP) {
      e.preventDefault();
      listItems && listItems[index - 1] && listItems[index - 1].focus();
    } else if (code === Keyboard.ESCAPE || code === Keyboard.TAB) {
      dropdownHidden && setDropdownHidden(!dropdownHidden);
      focusActiveEelement(e);
    } else if (code === Keyboard.ENTER) {
      setDropdownHidden(!dropdownHidden);
      focusActiveEelement(e);
      callback(data);
    }
  };

  const borderClip = (data) => {
    return data.length === 1 ? 'only-button' : dropdownHidden ? '' : 'not-hover';
  };

  return {
    dropdownHidden,
    dropdownRef,
    toggleDropdown,
    openDropDown,
    focusListItem,
    borderClip,
    setDropdownHidden,
  };
};
